import DatePicker from "react-datetime";
import "react-datetime/css/react-datetime.css";

export const DateTime = DatePicker;
